import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "alwaysShowAsHint"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/core/components/Forms/LabelText.js",
  _this = this;
import styled from 'styled-components';
import React, { useContext } from 'react';
import { FormFieldContext } from './FormField';
import MultilineTruncateParagraph from '../../../core/components/MultilineTruncateParagraph';
import { withTheme } from '../../ThemeProvider';
var TRANSITION_TIMEOUT = 200; // TODO Sudhir: Add documentation.

var LabelTextComponent = function LabelTextComponent(_ref, ref) {
  var children = _ref.children,
    alwaysShowAsHint = _ref.alwaysShowAsHint,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(FormFieldContext),
    onFocus = _useContext.onFocus,
    hasFocus = _useContext.hasFocus,
    hasValue = _useContext.hasValue;
  var renderAsHint = alwaysShowAsHint || hasFocus || hasValue;
  return /*#__PURE__*/React.createElement(MultilineTruncateParagraph, _extends({
    Typography: StyledLabel,
    numOfLines: renderAsHint ? 1 : 2,
    timeout: TRANSITION_TIMEOUT,
    onMouseDown: onFocus,
    renderAsHint: renderAsHint,
    ref: ref
  }, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }), children);
};
var StyledLabel = withTheme(styled.span.withConfig({
  displayName: "LabelText__StyledLabel",
  componentId: "sc-1w58nqj-0"
})(["user-select:none;text-align:left;", ";line-height:1.5;position:absolute;transition:", "ms ease;"], function (_ref2) {
  var coreTheme = _ref2.coreTheme,
    renderAsHint = _ref2.renderAsHint;
  return Object.assign({}, renderAsHint ? hintTextCss(coreTheme) : labelTextCss(coreTheme), {
    left: "".concat(coreTheme.space_4, "px")
  });
}, TRANSITION_TIMEOUT));
export var labelTextCss = function labelTextCss(coreTheme) {
  return {
    color: coreTheme.cl_sec_d1,
    fontSize: coreTheme.fs_xl,
    fontFamily: coreTheme.ff_sec_thin,
    top: '42px',
    transform: 'translate(0, -50%)'
  };
};
export var hintTextCss = function hintTextCss(coreTheme) {
  return {
    color: coreTheme.cl_ter_l2,
    fontSize: coreTheme.fs_sm,
    fontFamily: coreTheme.ff_sec_thin,
    top: '16px',
    width: 'calc(100% - 32px)'
  };
};
var LabelText = /*#__PURE__*/React.forwardRef(LabelTextComponent);
export default LabelText;